import { Tag as AntdTag } from "antd";
import styled from "styled-components";

const Tag = styled(AntdTag)`
	border-radius: 50px;
`;

export default Tag;
